export default __webpack_public_path__ + "static/media/slider_img2.4b1c9b0f.png";